import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {sendRichMessage}  from '../../utils/sendRichMessage';


const UsernameInput = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const reduxState = useSelector(state => state);
  const { ui } = useSelector(state=>state);
  const RmConfigs = ui?.config?.attributes.RichMediaConfigs;

  const validateUsername = (value) => {
    const usernameRegex = /^[a-zA-Z0-9]{3,15}$/;

    if (value.length < 3 || value.length > 15) {
      return RmConfigs.RichmediaUsernameCharacterLimitErrorMessage;;
    }

    if (!usernameRegex.test(value)) {
      return RmConfigs.RichmediaUsernameUnsupportedCharacterErrorMessage;;
    }

    return '';
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    setError(validateUsername(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validateUsername(username);
    if (!validationError) {
      setIsSubmitted(true);
      console.log('Submitted username:', username);
      sendRichMessage(username, reduxState);
    } else {
      setError(validationError);
    }
  };

  return (
    <form onSubmit={handleSubmit}
    style={{
      display: 'flex',
      flexFlow: 'column',
      width: 'auto',
      textAlign: 'left',
      background:'#e5e5ea',
      padding: '12px',
      borderRadius:'12px',
      margin:'12px 12px 0 12px'
    }}
    >
      <input
        type="text"
        id="username"
        className='rm-input'
        value={username}
        onChange={handleChange}
        placeholder={RmConfigs.RichmediaUsernamePlaceholder}
        disabled={isSubmitted}
        style={{ width: '150px', padding: '6px' }}
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <button
        type="submit"
        disabled={!!error || username === '' || isSubmitted}
        className='dafabet'
      >
      提交
      </button>
    </form>
  );
};

export default UsernameInput;
